/**
 * Mini Cart
 *
 * @module mini-cart
 * @version 1.0.0
 */

 const component = {

	/**
	 * Init module
	 * 
	 * @returns {undefined}
	 */
	init: () => {

		/** @global */
    	window.theme.mini_cart = component;

		component.target = document.querySelector("[data-mini-cart]");

		if(!component.target) return null;

		component._checkAttributeDisabled();
		component._initCloseEvents();
		component.initFocusTrap();
		component._initOpenEvents();
		//component._initHoverEvent();
	},

	/**
	 * start to listen the click button to close minicart
     * 
     * @returns {undefined}
	 */
	_initCloseEvents: () => {

		// Close minicart when click on overlay
		document.querySelector('[data-minicart-close]').addEventListener('click', (event) => {
			event.preventDefault();
			component._closeMinicart();
		});

		// Close minicart when click on close button
		document.querySelectorAll('[data-minicart-close-button]').forEach( (btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				component._closeMinicart();
			});
		});

		// Close minicart on press escape
		window.addEventListener('escape', (event) => {
			component._closeMinicart();
		});
	},

	/**
	 * hide minicart
     * 
     * @returns {undefined}
	 */
	 _closeMinicart: () => {

		component.disableFocusTrap();

		document.querySelector('body').classList.remove('active-mini-cart');

		//document.querySelector('[data-mini-cart-product-added-message]').classList.remove('active');
		
		// We need to use set time out to avoid issues with minicart animation
        setTimeout(() => {
            component.target.classList.remove("active");
			component.target.setAttribute('aria-hidden', 'true');
			component.disableOverlay();
			const minicartClosedEvent = new CustomEvent('minicart-closed');
        	window.dispatchEvent(minicartClosedEvent);
        }, 50);

	},

	/**
	 * check if the mini cart has a dataset data-minicart-disabled-for-mobile
     * 
     * @returns {boolean} button has the data attribute or not.
	 */
	 _checkAttributeDisabled: () => {

		if(window.screenMode == 'mobile') {

			let openButton = document.querySelector('[data-minicart-toggle]');

			if(openButton.hasAttribute('data-minicart-disabled-for-mobile')) {
				component.disableMiniCartForMobile = true;
			}
			else {
				component.disableMiniCartForMobile = false;
			}
		}
		else {
			component.disableMiniCartForMobile = false;
		}
	},

	/**
	 * open minicart when clicking on bag
     * 
     * @returns {undefined}
	 */
	 _initOpenEvents: () => {
		let openButton = document.querySelectorAll('[data-minicart-toggle]');

		openButton.forEach((btn) => {

			btn.addEventListener('click', event => {

				//Do not open mini cart for mobile that has data-minicart-disabled-for-mobile attribute
				component._checkAttributeDisabled();

				if(!component.disableMiniCartForMobile) {
					event.preventDefault();
					component._openMinicart();
				}
			});
		});
	},

	/**
	 * open mini cart when hovering on the cart icon
     * 
     * @returns {undefined}
	 */
	_initHoverEvent(){
		const openCart = document.querySelectorAll('[data-minicart-toggle],[data-mini-cart]');
		const closeCart = document.querySelector('[data-mini-cart]');
		openCart.forEach((element) =>{
			hoverintent(element, () => {
				if(closeCart != element){
					component._openMinicart();
				}
			}, () => {
				if(element == closeCart){
					component._closeMinicart();
				}
			});
		})
	},

	/**
	 * show minicart
     * 
     * @returns {undefined}
	 */
	 _openMinicart: () => {
		//Do not open mini cart for mobile that has data-minicart-disabled-for-mobile attribute
		component._checkAttributeDisabled();

		if(!component.disableMiniCartForMobile) {

			let quantity = window.theme.cart.getCartQuantity();

			component._updateMinicartData();


			//document.querySelector('[data-mini-cart-product-added-message]').classList.add('active');

			// We need to use set time out to avoid issues with minicart animation
			setTimeout(() => {
				component._updateFreeShippingBar();
				component.target.classList.add("active");
				component.target.setAttribute('aria-hidden', 'false');
				component.activeFocusTrap();
				component.enableOverlay();
				document.querySelector('body').classList.add('active-mini-cart');
			}, 400); 
			
		}
	},

	/**
	 * load all products in cart
     * 
     * @returns {undefined}
	 */
	 _updateMinicartData: () => {
		fetch('/cart.js', { credentials: 'same-origin' }).then(function(response) {
			return response.json();
		}).then(function(cart) {
			component._loadItems(cart);
			return cart;

		}).then((cart) => {

			component._updateMinicartPrices(cart);

		}).catch(function(error) {
			console.log(error);
		});
	},

	/**
	 * Enable minicart overlay
     * 
     * @returns {undefined}
	 */
	enableOverlay: () => {
		document.querySelector('[data-minicart-close].minicart-overlay').classList.add('active');
		document.querySelector('[data-minicart-close]').focus();
	},

	/**
	 * Disable minicart overlay
	 * 
	 * @returns {undefined}
	 */
	disableOverlay: () => {
		document.querySelector('[data-minicart-close].minicart-overlay').classList.remove('active');
	},

	/**
	 * Update product added message
	 * 
	 * @param {integer} qty_added Product quantity added to the cart.
	 * @param {integer} id Product ID of product added to the cart.
	 * @returns {undefined}
	 */
	_updateProductAddedMessage: (qty_added, id) => {

		let message = component.target.querySelector('[data-mini-cart-product-added-message]');

		if(!message) return false;

		if(qty_added == 0) {

			message.innerHTML = "";
			message.classList.remove("active");	

		} else if(qty_added == 1){

			message.innerHTML = "<span>You added 1 product to your bag!</span>";
			message.classList.add("active");

		} else {

			message.innerHTML = "<span>You added " + qty_added + " products to your bag!</span>";
			message.classList.add("active");
		}
	},

	/**
	 * load all html products 
	 * 
	 * @param {integer} cart Cart object.
	 * @returns {undefined}
	 */
	 _loadItems: (cart) => {
		let div_items = document.querySelector('[data-mini-cart-items]');

		if(cart.item_count > 0) {

			if(div_items) {
				div_items.classList.remove("empty");

				div_items.innerHTML = "";
				
				return new Promise((resolve, reject) => {

					cart.items.forEach((item) => {
						component._loadHtmlItem(item).then(htmlItem => {

							if(htmlItem) {

								div_items.innerHTML += htmlItem;
								component._initEditFuctions();

							}
						});
					});

					resolve(true);

				}).then(() => {
					setTimeout(() => {
						//Init all input quantity events
						window.theme.quantity_selector.load();
	
						//Listen when update the input quantity
						component._initListenQuantity();
	
						//Init the event when delete a product
						component._initListenTrashButton();

					}, 900);

					//Update count icon
					window.theme.cart._setCartQuantity(cart.item_count);
				});	
			}
		}
		else {
			div_items.classList.add("empty");
			div_items.innerHTML = `<div class="mini-cart__empty">There's nothing in your bag</div>`;

			//Update count icon
			window.theme.cart._setCartQuantity(0);
		}
	},

	_initEditFuctions: () => {
		let editModals = document.querySelectorAll('[data-edit-modal]');

		editModals.forEach(editModal => {
			const id = editModal.dataset.editModal;
			const editBtn = document.querySelector(`[data-edit-open="${id}"]`);

			if(editBtn) {
				editBtn.addEventListener('click', (event) => {
					editModal.classList.add('active');
				});
			}
			


			document.querySelectorAll(`[data-edit-close="${id}"]`).forEach(closeButton => {
				closeButton.addEventListener('click', (event) => {
					editModal.classList.remove('active');
				});
			});

			const swiperContainer = editModal.querySelector(`[data-edit-slide="${id}"]`);
			if (swiperContainer) {
			new Swiper(swiperContainer, {
				loop: true,
				navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
				},
				pagination: {
				el: '.swiper-pagination',
				clickable: true,
				},
			});
			}
		});
	},

	/**
	 * load html product
	 * 
	 * @param {object} item Item object.
	 * @returns {string}
	 */
	 _loadHtmlItem: (item) => {

		return new Promise((resolve, reject) => {

			window.theme.product.loadProduct(item.handle, true).then(product => {

				let html_items = miniCartTemplate.mini_cart_items_layout;
				let image_src = "";
				let html_options = "";

				// Products Image
				if(item.featured_image) {
					image_src = item.featured_image.url.replace(".jpg", "_150x150.jpg").replace(".png", "_150x150.png");
				}
				else {
					image_src = "http://via.placeholder.com/150x150.png";
				}

				html_items = html_items.replace(/{{itemImageSrc}}/g, image_src);

				// Random Number
				let random_number = Math.floor(Math.random() * 10000) + 1;
				html_items = html_items.replace(/{{randomNumber}}/g, random_number);

				html_items = html_items.replace(/{{itemIventType}}/g, product.vendor?.toLowerCase() === 'event' ? 'disabled="true"' : '');

				// Products Title
				if(item.product_title) {
					let item_url = item.url;
					let item_title = item.product_title;

					html_items = html_items.replace(/{{itemUrl}}/g, item_url);
					html_items = html_items.replace(/{{itemTitle}}/g, item_title);
				}

				html_items = html_items.replace(/{{itemVendor}}/g, item.vendor);
				html_items = html_items.replace(/{{itemProductId}}/g, item.product_id);

				// Variant Option
				if(item.options_with_values) {
					item.options_with_values.forEach((options) => {
						console.log(options);
						if(options.name == "Size") {
							html_options += "<div class='mini-cart__item-options'>" + options.name + " : " + options.value + "</div>";
						} else if (item.vendor == 'Event' && options.name == "Times") {
							html_options += "<div class='mini-cart__item-options'>Time: " + options.value + "</div>";
						}
					});
				}

				// Product properties
				if (Object.keys(item.properties).length) {
					for (const property in item.properties) {
						console.log(property);
						if(property == "Size") {
							html_options += "<div class='mini-cart__item-options'>" + property + " : " + item.properties[property] + "</div>";
						}
					}
				}

				html_items = html_items.replace(/{{itemOptions}}/g, html_options);

				// Variant ID
				let item_id =  item.id;
				html_items = html_items.replace(/{{itemID}}/g, item_id);


				html_items = html_items.replace(/{{itemID}}/g, item.vendor);

				// Variant Price
				if(item.price) {


					let item_price = window.theme.money.format(item.price);

					// if(window.appikon.discounts) {
					// 	if(window.appikon.discounts.cart) {
					// 		if(window.appikon.discounts.cart.items) {
					// 			window.appikon.discounts.cart.items.forEach((app_item) => {
					// 				if(app_item.variant_id == item.id) {
					// 					if(app_item.discounted_price_format) {
					// 						item_price = app_item.discounted_price_format;
					// 					}
					// 					else {
					// 						item_price = app_item.original_price_format;
					// 					}
					// 				}
					// 			});
					// 		}
					// 	}
					// }

					if (product.vendor == 'Inner Circle') {
						html_items = html_items.replace(/{{itemPrice}}/g, "FREE");
					} else {
						html_items = html_items.replace(/{{itemPrice}}/g, item_price);
					}

				} else if (product.vendor == 'Event' && product.price == 0) {
					html_items = html_items.replace(/{{itemPrice}}/g, "$0.00");
				} else {
					html_items = html_items.replace(/{{itemPrice}}/g, "$0.00");
				}

				// Variant Compare At Price
				if(product.compare_at_price && (product.compare_at_price > product.price)) {
					let item_compareAtPrice = window.theme.money.format(product.compare_at_price);
					html_items = html_items.replace(/{{compareAtPrice}}/g, item_compareAtPrice);
				}
				else {
					html_items = html_items.replace(/{{compareAtPrice}}/g, '');
				}

				// Variant quantity
				let item_quantity =  item.quantity;
				html_items = html_items.replace(/{{itemQuantity}}/g, item_quantity);

				let editBtn = (product.variants.length > 1 && product.vendor !== 'Route' && product.vendor !== 'Event' && product.vendor !== 'Inner Circle') ? `<button class="btn-link mini-cart__edit-button" data-edit-open="${item.id}">Edit</button>` : '';				
				html_items = html_items.replace(/{{editBtn}}/g, editBtn);

				let editModal = (product.variants.length > 1 && product.vendor !== 'Route' && product.vendor !== 'Event' && product.vendor !== 'Inner Circle')  ? `
					<div class="mini-cart__edit-modal" data-edit-modal="${item.id}" data-handle="${product.handle}">
						<div class="mini-cart__edit-modal-wrapper">
							<div class="swiper" data-edit-slide="${item.id}">
								<div class="swiper-wrapper">
									${product.images.map(image => `<div class="swiper-slide"><img loading="lazy" src="${image.src}" alt="${image.alt || 'Product Image'}"></div>`).join('')}
								</div>
								<div class="swiper-button-next"></div>
								<div class="swiper-button-prev"></div>
								<div class="swiper-pagination"></div>
							</div>

							<component-addtocart data-handle="${product.handle}">
								<form class="mini-cart__edit-form" action="/cart/add" method="post" id="product_form_${item.id}" data-item-qty=${item.quantity} data-edit-form="${item.id}" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-quick-view-form>
									<input type="hidden" name="form_type" value="product">
									
									<input type="hidden" name="utf8" value="✓">

									<input id="vendor" type="hidden" value=${product.vendor} name="properties[Vendor]">

									<input type="hidden" id="custom_text" name="properties[FINAL SALE]" value="YES">

									<input type="hidden" name="quantity" value="${item.quantity}">

									<variant-selector data-handle="${product.handle}"></variant-selector>

									<component-swatch data-handle="${product.handle}"></component-swatch>

									<div class="quick-view__error" data-error-message></div>

									<div class="mini-cart__edit-btns-wrapper">
										<button type="button" class="mini-cart__edit-cancel"  data-edit-close="${item.id}">Cancel</button>
										
										<button type="submit" data-edit-btn name="add" class="btn mini-cart__edit-confirm">
											Confirm
										</button>
									</div>
								</form>
						</component-addtocart>
					</div>
					<div class="mini-cart__edit-modal-overlay" data-edit-close="${item.id}"></div>		
				</div>
				` : '';

				html_items = html_items.replace(/{{editModal}}/g, editModal);

				

				resolve(html_items);
			});
        });
	},

	/**
	 * load subtotal discount
	 * 
	 * @param {object} item Item object.
	 * @returns {undefined}
	 */
	 loadSubtotalDiscount: (item) => {

		return new Promise((resolve, reject) => {

			window.theme.product.loadProduct(item.handle, true).then(product => {

				/* App Discount */
				if(window.appikon.discounts.cart) {

					window.appikon.discounts.cart.items.forEach((app_item) => {

						// Compare the cart item with app item
						if(app_item.variant_id == item.id) {

							let original_price = 0;
							let price = 0;
							let current_variant = null;

							// Get product variant
							product.variants.forEach((variant) => {
								if(app_item.variant_id == variant.id) {
									current_variant = variant;
								}
							});

							if(app_item.totalDiscount) {

								price = app_item.discounted_price * 100;

								// Check product compare at price (Apply product price with app)
								if(current_variant.compare_at_price) {

									if(current_variant.compare_at_price > (app_item.original_price * 100)) {
										component.originalSubtotal += current_variant.compare_at_price * app_item.quantity;
										original_price = current_variant.compare_at_price;
										
									}
									else {
										component.originalSubtotal += (app_item.original_price * 100) * app_item.quantity;
										original_price = app_item.original_price * 100;
									}
								}
								else {
									component.originalSubtotal += (app_item.original_price * 100) * app_item.quantity;
									original_price = app_item.original_price * 100;
								}
							}
							else {

								// Get variant price
								price = current_variant.price;

								// Apply product price without app
								if(current_variant.compare_at_price){
									component.originalSubtotal += current_variant.compare_at_price * app_item.quantity;
									original_price = current_variant.compare_at_price;
								}
								else {
									component.originalSubtotal += current_variant.price * app_item.quantity;
								}
							}

							// Set product price
							let productPrice = document.querySelector('[data-minicart-item-id="'+ app_item.variant_id +'"] [data-minicart-item-price]');

							if (product.vendor == 'Inner Circle') {
								productPrice.innerHTML = "FREE";
							} else {
								productPrice.innerHTML = window.theme.money.format(price);
							}
								


							// Set product compare at price
							let productCompareAtPrice = document.querySelector('[data-minicart-item-id="'+ app_item.variant_id +'"] [data-minicart-item-compare-at-price]');
							
							if(original_price) {
								productCompareAtPrice.innerHTML = window.theme.money.format(original_price);
							}
							else if (productCompareAtPrice) {
								productCompareAtPrice.innerHTML = '';
							}

							// Set discount message
							let productDiscountMessage = document.querySelector('[data-minicart-item-dicount-message="'+ app_item.variant_id +'"]');

							if(productDiscountMessage && app_item.upsell_note) {
								productDiscountMessage.classList.add('active');
								productDiscountMessage.innerHTML = app_item.upsell_note;
							}
							else {
								productDiscountMessage.classList.remove('active');
								productDiscountMessage.innerHTML = '';
							}
						}
					});
				}
				else { /* Shopify Discount */
					if(product.compare_at_price){
						component.originalSubtotal += product.compare_at_price * item.quantity;
					}
					else {
						component.originalSubtotal += product.price * app_item.quantity;
					}
				}
				
				resolve(true);
			});
        });
	},

	/**
	 * Listen when update the input quantity
     * 
     * @returns {undefined}
	 */
	_initListenQuantity: () => {

		component.target.querySelectorAll('[data-cart-page-item-id]').forEach(element => {
			element.addEventListener('change', event => {
				const container = element.parentNode.parentNode.parentNode;
				var productId = event.target.dataset.cartPageItemId;
				if(container){
					const el = container.querySelector('.mini-cart__vendor') || '';
					const vendor = el.innerText;
					if(vendor === 'EVENT' || vendor === 'Event' || vendor === 'event'){
						
						const productIdCurrent = parseInt(el.dataset.minicartItemProductId);
						const quantityChangedEvent = new CustomEvent('quantity-changed', {
							detail: {
								productId: productIdCurrent,
								quantity: event.target.value
							}
						});
						window.dispatchEvent(quantityChangedEvent);					
					}
				}

				if(productId) {
					component._updateMiniCart(productId, event.target.value);
				}
			});
		});
	},

	/**
	 * Update the minicart
     * 
     * @returns {undefined}
	 */
	 _updateMiniCart: (id, qty) => {

		return new Promise((resolve, reject) => {

			// Create the request
			let request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;'
				},
				body: JSON.stringify({
					id: id,
					quantity: qty
				})
			};

			// Make a request
			fetch('/cart/change.js', request).then(function(response) {
				return response.json();
			}).then(function(json) {

				if (json.status && json.status !== 200) {
					var error = new Error(json.description);
					error.isFromServer = true;
					throw error;
				}

				component._updateFreeShippingBar();
				component._updateMinicartData();
				component._checkAvailabilityStock(id, qty);

				resolve(true);
				
			}).catch(function(error) {
				console.log(error);
				reject(error);
			});

		});
	},

	/**
	 * Update the progress bar (Free Shipping App)
     * 
     * @return {undefined}
	 */
	_updateFreeShippingBar: () => {
		
		if (typeof window.updateFSPB != 'undefined') {
			window.updateFSPB();
		}
	},

	/**
	 * check if product has unavailability stock
     * 
     * @returns {undefined}
	 */
	_checkAvailabilityStock: (id, qty_added) => {

		let message = component.target.querySelector('[data-error-message]');

		if(!message) return false;

		fetch('/cart.js', { credentials: 'same-origin' }).then(function(response) {
			return response.json();
		}).then(function(cart) {

			cart.items.forEach(item => {
				if(id == item.id) {
	
					if(qty_added > item.quantity) {
						message.innerHTML = "";
						message.append("All " + item.quantity + " " + item.title + " are in your cart.");
						message.classList.add("active");
	
						let input = document.querySelector('[data-cart-page-item-id=\"' + item.id + '\"]');
	
						if(input) {
							input.value = item.quantity;
						}
					}
					else {
						message.innerHTML = "";
						message.classList.remove("active");
					}
				}
			});

		}).catch(function(error) {
			console.log(error);
		});
	},

	/**
	 * Listen when click in remove item
     * 
     * @returns {undefined}
	 */
	 _initListenTrashButton: () => {

		document.querySelectorAll('[data-minicart-remove-item]').forEach((element) => {
			element.addEventListener('click', event => {
				event.preventDefault();

				var productId = element.dataset.minicartVariantId
				const quantityChangedEvent = new CustomEvent('quantity-changed', {
                    detail: {
                        productId: productId,
                        quantity: 0
                    }
                });

                window.dispatchEvent(quantityChangedEvent);

				if(productId) {
					component._updateMiniCart(productId, 0);
				}
			});
		});
	},

	/**
	 * Upload all components inside minicart as prices, numbers, etc
     * 
	 * @param {cart} cart A cart object.
     * @returns {undefined}
	 */
	 _updatePrices: (cart) => {
		const counter = setInterval(callback.bind(this), 50);
		function callback() {
			// Stop the callback since we don't need to wait for appikon
			clearInterval(counter);
			
			var originalSubtotal = document.querySelector("[data-minicart-final-subtotal]");
			component.originalSubtotal = 0;

			if(originalSubtotal) {
				// Just show regular cart subtotal since we don't have appikon discounts
				originalSubtotal.innerHTML = window.theme.money.format(cart.items_subtotal_price);
			}
		}
	},

	/**
	 * Update all mini cart prices
     * 
	 * @param {cart} cart A cart object.
     * @returns {undefined}
	*/
	_updateMinicartPrices: (cart) => {
		fetch('/cart.js', { credentials: 'same-origin' }).then(function(response) {
			return response.json();
		}).then((cart) => {

			component._updatePrices(cart);

		}).catch(function(error) {
			console.log(error);
		});
	},

	/**
	 * Init minicart focus trap
     * 
     * @returns {undefined}
	 */
     initFocusTrap: () => {

        component.focusTrap = focusTrap.createFocusTrap(component.target, { clickOutsideDeactivates: true });
    },

	/**
	 * Fetch related products
	 * 
	 * @returns {undefined}
	 */
	fetchRelatedProducts: (productId) => { 


		fetch(`/recommendations/products?section_id=related-products&product_id=`  +  productId + `&limit=9`)
		.then((response) => response.text())
		.then((text) => {

			

			const relatedProductsContainer = document.querySelector('[data-minicart-related-products-container]');

			const html = document.createElement('div');
			html.innerHTML = text;
		
			const recommendations = html.querySelector('related-products');

			recommendations.querySelectorAll('.quick-add-to-cart__start-button').forEach((button) => {
				button.dataset.minicart = true;
			});


			if (recommendations && recommendations.innerHTML.trim().length > 0) {
				relatedProductsContainer.innerHTML = recommendations.innerHTML;
			}

			if (relatedProductsContainer.querySelector('product-card')) {
				component.target.classList.add('product-recommendations--loaded');
			}
			})
			.then(() => {

			// Init Slider
			component.initSlider();

		})
		.catch(error => {
			console.error('Error when searching related products from minicart:', error);
		});
	},

	initSlider: () => {

		component.swiper = component.target.querySelector('[data-swiper]');
		const swiperMediaPagination = component.target.querySelector('.swiper-pagination');
  
		let defaultOptions = {
		  preloadImages: true,
		  slidesPerView: 1.5,
		  watchSlidesVisibility: true,
		  watchSlidesProgress: true,
		  spaceBetween: 12,
		  lazy: {
			loadPrevNext: true,
		  },
		  autoHeight: false,
		  pagination: {
			el: swiperMediaPagination,
			clickable: true
		  },
		  navigation: {
			nextEl: component.target.querySelector('.swiper-button-next'),
			prevEl: component.target.querySelector('.swiper-button-prev')
		  },
		  pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
		  },
		  breakpoints: {
			425: {
			  slidesPerView: 1.6,
			  spaceBetween: 12
			},
			768: {
			  slidesPerView: 1.6,
			  spaceBetween: 12
			},
			1024: {
				slidesPerView: 1.6,
				spaceBetween: 12
			},
			1440: {
				slidesPerView: 1.6,
				spaceBetween: 12
			}
		},
		on: {
			init: () => { },
			afterInit: () => {
				document.querySelector('[data-minicart-related-products-container]').classList.remove('hidden');
				component.target.querySelector('.related-products__loading').classList.add('hidden');
			}             
		}
		}
    
		component.options = {...defaultOptions};
  
		component.slider = new Swiper(component.swiper, component.options);
	},

	/**
	 * Ative minicart focus trap
     * 
     * @returns {undefined}
	 */
	 activeFocusTrap: () => {

        if (component.focusTrap) {
            component.focusTrap.activate();
        }
    },

	/**
	 * Disable minicart focus trap
     * 
     * @returns {undefined}
	 */
	disableFocusTrap: () => {

		if (component.focusTrap) {
			component.focusTrap.deactivate();
		}
	},
	
	/**
	 * Get the quantity of a product in the cart by its ID
	 * @param {string} productId - The ID of the product to search for
	 * @returns {Promise<number>} - The quantity of the product in the cart
	 */
	getProductQuantityById: (productId) => {
		return new Promise((resolve, reject) => {
			fetch('/cart.js', { credentials: 'same-origin' })
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					return response.json();
				})
				.then((cart) => {
					let qty = 0;
					cart.items.forEach((item) => {
						if(item.product_id === productId){
							qty += item.quantity;
						}
					});
					resolve(qty);
				})
				.catch((error) => {
					console.error('Error retrieving cart:', error);
					reject(error);
				});
		});
	}
};

export default component;